import React from 'react';
import { useLang } from '../contexts/LanguageContext';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';

const faqs = [
  {
    q: { it: 'Come funziona il Biolosophy Value?', en: 'How does Biolosophy Value work?' },
    a: {
      it: "Riporta un capo biolosophy e ricevi uno sconto sul nuovo acquisto in base a quanto tempo lo hai custodito: 20% già dal primo anno di acquisto, +10% ogni anno successivo, fino a un capo gratuito di pari valore al nono anno. Lo sconto si applica dopo l'approvazione del reso. Iscriviti al Club Biolosophy, registra il tuo acquisto e accedi ai vantaggi dal tuo account.",
      en: "Bring back a biolosophy garment and receive a discount on your new purchase based on how long you have kept it: 20% from the very first year, +10% each following year, up to a free garment of equal value in the ninth year. The discount is applied after the return has been approved. Join Club Biolosophy, register your purchase and access your benefits from your account.",
    },
  },
  {
    q: { it: 'I vostri capi sono davvero 100% biologici?', en: 'Are your garments really 100% organic?' },
    a: {
      it: 'Sì. Utilizziamo esclusivamente tessuti biologici certificati: cotone organico, lino e lana merino, coltivati e lavorati senza pesticidi né sostanze chimiche nocive.',
      en: 'Yes. We use only certified organic fabrics: organic cotton, linen and merino wool, grown and processed without pesticides or harmful chemicals.',
    },
  },
  {
    q: { it: 'Dove vengono prodotti i capi?', en: 'Where are the garments made?' },
    a: {
      it: 'Ogni capo è prodotto interamente in Italia da laboratori artigianali selezionati, nel rispetto dei lavoratori e delle tradizioni tessili italiane.',
      en: 'Every garment is made entirely in Italy by selected artisan workshops, respecting workers and Italian textile traditions.',
    },
  },
  {
    q: { it: 'Cosa sono i capi Pre-Loved?', en: 'What are Pre-Loved garments?' },
    a: {
      it: 'Sono capi restituiti tramite il programma Biolosophy Value, rigenerati e certificati dai nostri artigiani. Ogni pezzo è unico e viene proposto a un prezzo accessibile nella sezione Pre-Loved.',
      en: 'They are garments returned through the Biolosophy Value program, regenerated and certified by our artisans. Every piece is unique and offered at an accessible price in the Pre-Loved section.',
    },
  },
  {
    q: { it: 'Quali metodi di pagamento accettate?', en: 'Which payment methods do you accept?' },
    a: {
      it: 'Accettiamo carte di credito e debito (tramite Stripe) e PayPal. Tutti i pagamenti sono protetti e crittografati.',
      en: 'We accept credit and debit cards (via Stripe) and PayPal. All payments are secure and encrypted.',
    },
  },
  {
    q: { it: 'Posso restituire un capo se non mi va bene?', en: "Can I return a garment if it doesn't fit?" },
    a: {
      it: 'Certo: hai 14 giorni dalla consegna per un reso gratuito, purché il capo non sia stato indossato e abbia le etichette originali. Consulta la pagina Spedizioni e Resi per i dettagli.',
      en: 'Of course: you have 14 days from delivery for a free return, as long as the garment is unworn with original tags. See the Shipping & Returns page for details.',
    },
  },
  {
    q: { it: 'Come scelgo la taglia giusta?', en: 'How do I choose the right size?' },
    a: {
      it: 'Consulta la nostra Guida alle Taglie con le misure dettagliate di ogni vestibilità. In caso di dubbio, scrivici a info@biolosophy.it: ti aiuteremo a scegliere.',
      en: 'Check our Size Guide with detailed measurements for every fit. If in doubt, write to us at info@biolosophy.it — we will help you choose.',
    },
  },
];

export default function FaqPage() {
  const { t } = useLang();

  return (
    <div data-testid="faq-page" className="min-h-screen bg-[#FAF9F6] pt-24 pb-24">
      <section className="px-6 md:px-12 lg:px-24 py-16">
        <div className="max-w-3xl">
          <p className="overline mb-4">{t({ it: 'Assistenza', en: 'Customer Care' })}</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-light tracking-tighter text-[#1C1917] mb-16">
            {t({ it: 'Domande Frequenti', en: 'Frequently Asked Questions' })}
          </h1>

          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, idx) => (
              <AccordionItem
                key={idx}
                value={`faq-${idx}`}
                className="bg-white border border-[#E5E0D8] px-6"
                data-testid={`faq-item-${idx}`}
              >
                <AccordionTrigger className="text-left font-medium text-[#1C1917] hover:text-[#4A5D23] hover:no-underline">
                  {t(faq.q)}
                </AccordionTrigger>
                <AccordionContent className="text-sm text-[#1C1917]/70 leading-relaxed">
                  {t(faq.a)}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </div>
  );
}
